import { css } from 'styled-components';
export const BKJThemeDialog = {
    Default: css ``,
    Danger: css ``,
};
//# sourceMappingURL=BKJDialog.theme.js.map